import { filter } from 'rxjs/operators';
import { Component, HostListener, AfterViewInit, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';

import { ContactService } from '../../../services/contacts/contact.service';
import { ContactStoreService } from '../../../services/contacts/contact-store.service';
import { NotyService } from '../../../services/common/noty.service';

declare var $: any;

@Component({
  selector: 'app-contact-show',
  templateUrl: './contact-show.component.html',
  styleUrls: ['./contact-show.component.scss'],
  providers: [ContactStoreService],
})
export class ContactShowComponent implements AfterViewInit, OnInit {
  /**
   * Contact id
   * @type {number}
   */
  contactId: number;

  /**
   * Contact info for left side of page
   * @type {any}
   */
  contactInfo: any;

  /**
   * Indicates loading of contact info
   * @type {boolean}
   */
  loadingContactInfo: boolean = true;

  /**
   * Browser route params parsed subscription
   * @type {Subscription}
   */
  routerEventsSubscription: Subscription;

  /**
   * Indicates if sidebar is expanded to the left
   * @type {boolean}
   */
  sidebarMaximized: boolean = false;

  /**
   * Indicates if sidebar is open in small screens
   * @type {boolean}
   */
  sidebarOpen: boolean = false;

  /**
   * Subscribe to route parse events
   * @param {ContactService} private contactService Contact Resource Service
   * @param {NotyService}    public  notyService    Notification on screen
   * @param {ActivatedRoute} private route          Current browser route information
   * @param {Router}         private router         Angular router
   */
  constructor(private contactService: ContactService, private contactStoreService: ContactStoreService, public notyService: NotyService, private route: ActivatedRoute, private router: Router) {
    this.contactStoreService.contactShowComponent = this;
    this.routerEventsSubscription = this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event) => {
      this.contactId = Number(this.route.snapshot.params['id']);
      this.loadContact();
    });
  }

  // Component lifecycle methods

  ngOnInit() {
    this.contactId = Number(this.route.snapshot.params['id']);
    this.loadContact();
  }

  /**
   * Angular component lifecycle event called after view initializes
   */
  ngAfterViewInit() {
    setTimeout(() => {
      this.content_sidebar_scroll();
    }, 1000);
    setTimeout(() => {
      this.content_sidebar_scroll();
    }, 5000);
    setTimeout(() => {
      this.content_sidebar_scroll();
    }, 10000);
  }

  // Component methods

  // Event Listeners

  /**
   * Listener for page scroll event
   * @param {scroll'} 'window  event type
   * @param {[type]}  '$event' event object
   */
  @HostListener('window:scroll', ['$event'])
  window_scroll(event: Event) {
    this.content_sidebar_scroll();
  }

  /**
   * Listener for page resize event
   * @param {resize'} 'window  event type
   * @param {[type]}  '$event' event object
   */
  @HostListener('window:resize', ['$event'])
  window_resize(event: Event) {
    this.content_sidebar_scroll();
  }

  /**
   * Load contact info
   */
  loadContact() {
    this.contactService.contactInfo(this.contactId).then((response_json) => {
      this.loadingContactInfo = false;
      this.contactInfo = response_json;
      if (this.contactInfo && this.contactInfo.url)
        this.contactService.htmlSrcdoc(this.contactId).then((response_json) => {
          if (response_json.html) $('#contact_url_iframe').attr('srcdoc', response_json.html);
        });
    });
  }

  // Functions for UI manipulation using vanilla JS or jQuery

  /**
   * UI sidebar position and height adjust on page resize or scroll
   */
  content_sidebar_scroll() {
    var content_main = document.getElementById('content-main');
    var content_sidebar = document.getElementById('content-sidebar');
    var sidebar_height = window.innerHeight;
    if (content_sidebar && content_main) {
      if (content_main.getBoundingClientRect().top > 19) {
        content_sidebar.style.position = 'absolute';
        content_sidebar.style.top = content_main.offsetTop + 10 + 'px';
        sidebar_height -= content_main.getBoundingClientRect().top + 20;
        //console.log('greater ' + matter_sidebar.style.top);
      } else {
        content_sidebar.style.position = 'fixed';
        content_sidebar.style.top = '20px';
        sidebar_height -= content_sidebar.getBoundingClientRect().top + 20;
        //console.log('lesser ' + matter_sidebar.style.top);
      }
      if (content_sidebar.clientHeight != sidebar_height) content_sidebar.style.height = sidebar_height + 'px';
    }
  }
}
